import React, { useMemo } from "react";
import {
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import ReactNumber from "react-number-format";
import ReactTable from "@dhn/components/molecules/data-table";
import ModalEditTaxReceipt from "../modals/ModalEditTaxReceipt";
import useActions from "./useActions";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";

export default function TaxesTab({ dataDoctor, state: centerState, onChange }) {
  const issueFiscalReceipts =
    centerState?.pharmacyProvider?.issueFiscalReceipts;

  const [{ state: taxesState, filteredData }, actions] = useActions({
    pharmacyProviderId:
      centerState?.pharmacyProvider?.id || dataDoctor?.centerId,
  });

  const { query, isModalOpen, selectedReceipt } = taxesState;

  const showTable = issueFiscalReceipts === true;

  const onChangeMonthlyClosingDay = ({ floatValue }) =>
    onChange("monthlyClosingDay", floatValue ?? null, "pharmacyProvider");

  const columns = useMemo(
    () => [
      {
        Header: "Tipo de Comprobante",
        accessor: "name",
      },
      {
        Header: "Prefijo",
        accessor: "prefix",
        className: "text-center",
      },
      {
        Header: "Ultimo Comprobante",
        dataType: "fiscalNumber",
        className: "text-center",
        id: "lastVoucher",
        accessor: (row) => row?.last || row?.lastSeq || "",
      },
      {
        Header: "Disponibles",
        className: "text-right",
        accessor: "available",
      },
      {
        Header: "Fin de Secuencia",
        className: "text-right",
        accessor: "endSeq",
      },
      {
        Header: "Opciones",
        Cell: ({ original }) => (
          <Button
            color="secondary"
            size="sm"
            className="btn-color-gray card-header-action"
            onClick={() => actions.handleEdit(original)}
          >
            <i className="fa fa-pencil"></i>
            {" Editar"}
          </Button>
        ),
      },
    ],
    [actions],
  );

  return (
    <div className="animated fadeIn">
      <Row form className="mb-3 align-items-end">
        <Col xs="auto">
          <Label className="d-block">Está Registrado en la DGII</Label>
          <SelectableOptionGroup columns={2}>
            <SelectableOption
              key="issue-fiscal-receipts-yes"
              compact
              icon="fa-check"
              title="Sí"
              inputType="radio"
              inputName="issueFiscalReceipts"
              checked={issueFiscalReceipts === true}
              onChange={() =>
                onChange("issueFiscalReceipts", true, "pharmacyProvider")
              }
            />
            <SelectableOption
              key="issue-fiscal-receipts-no"
              compact
              icon="fa-times"
              title="No"
              inputType="radio"
              inputName="issueFiscalReceipts"
              checked={issueFiscalReceipts === false}
              onChange={() =>
                onChange("issueFiscalReceipts", false, "pharmacyProvider")
              }
            />
          </SelectableOptionGroup>
        </Col>
        <Col xs="auto" className="ml-md-4">
          <Label className="d-block">Día de corte del cierre mensual</Label>
          <div className="d-flex align-items-center">
            <div className="tw-w-24">
              <ReactNumber
                customInput={Input}
                className="bg-white text-center"
                placeholder="Último"
                decimalScale={0}
                allowNegative={false}
                isAllowed={({ floatValue }) =>
                  floatValue === undefined ||
                  (floatValue >= 1 && floatValue <= 31)
                }
                value={centerState?.pharmacyProvider?.monthlyClosingDay ?? ""}
                onValueChange={onChangeMonthlyClosingDay}
              />
            </div>
            <span
              id="monthly-closing-day-help"
              className="dhn-info-hint ml-2"
              tabIndex={0}
              role="img"
              aria-label="Información del día de corte"
            >
              <i className="fa fa-info-circle" aria-hidden="true"></i>
            </span>
            <UncontrolledTooltip
              target="monthly-closing-day-help"
              placement="right"
            >
              Las ventas posteriores a este día pasan al período del mes
              siguiente. Vacío corta el último día del mes. El cambio aplica a
              partir del próximo período.
            </UncontrolledTooltip>
          </div>
        </Col>
        {showTable && (
          <Col xs={12} md={3} className="mt-2 mt-md-0 ml-md-auto dhn-animate-fade">
            <InputGroup className="dhn-search-input">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-search" aria-hidden="true"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Buscar comprobante"
                value={query}
                onChange={({ target }) => actions.onChange("query", target.value)}
              />
            </InputGroup>
          </Col>
        )}
      </Row>

      {showTable && (
        <Row form>
          <Col md={12}>
            <ReactTable
              className="-striped -highlight"
              defaultPageSize={10}
              minRows={0}
              data={filteredData}
              columns={columns}
            />
          </Col>
        </Row>
      )}

      <ModalEditTaxReceipt
        isOpen={isModalOpen}
        toggle={actions.toggleModal}
        receiptData={selectedReceipt}
        dataDoctor={dataDoctor}
      />
    </div>
  );
}
